import { QueryParamService } from './services/queryParamService';

$(document).ready(function () {
  const queryParamService = new QueryParamService();
  queryParamService.saveQueryParam('cjevent', 'cjevent');
});
